import { BaseService } from './BaseService';
import { HomeFeedResponse } from 'src/types';

export class HomeService extends BaseService {
  async getFeed(param: Record<string, any>): Promise<HomeFeedResponse> {
    return this.get('/api/v1/home_feed', param);
  }

  async getCollectionByName(collectionName: string): Promise<any> {
    return this.get(`/api/v1/collections/${collectionName}`);
  }
}

export default new HomeService();
